import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { handleSafeAppTransaction } from 'modules/api/methods/handleSafeAppTransaction';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { delegateClaim } from 'modules/pool/methods/delegateClaim';

interface IClaimArgs {
  poolAddress: Address;
}

export const { useDelegateClaimMutation } = api.injectEndpoints({
  endpoints: build => ({
    delegateClaim: build.mutation<boolean, IClaimArgs>({
      queryFn: queryFnNotifyWrapper<IClaimArgs, void, boolean>(
        async ({ poolAddress }, { dispatch }) => {
          const walletClient = getWalletClient();
          const publicClient = getPublicClient();

          const txPromise = delegateClaim(walletClient, {
            poolAddress,
          });

          await handleSafeAppTransaction({
            txPromise,
            dispatch,
            publicClient,
            accountAddress: asAddress(walletClient.account?.address),
          });

          return {
            data: true,
          };
        },
      ),
      invalidatesTags: [cacheTags.claim, cacheTags.account],
    }),
  }),
});
